import { FormControl, InputLabel, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const Label = styled(InputLabel)<{ disabled?: boolean }>(
  ({ theme, disabled = false }) => ({
    fontSize: pxToRem(16),
    lineHeight: theme.typography.lineHeight.sm,
    fontWeight: theme.typography.fw_regular_400,
    color: disabled
      ? theme.palette.text.textSecondary
      : theme.palette.text.textPrimary,
    display: "flex",
    alignItems: "center",
    transform: "none",
    gap: pxToRem(8),

    "&.Mui-focused": {
      color: disabled
        ? theme.palette.text.textSecondary
        : theme.palette.stroke.strokeBrand,
    },
  })
);

export const Required = styled("span")<{ disabled?: boolean }>(({ theme }) => ({
  color: theme.palette.colorsBase.red_0,
  marginLeft: pxToRem(-4),
}));

export const Wrapper = styled(FormControl)<{
  hasLabel: boolean;
}>(({ theme, hasLabel }) => ({
  "& .MuiSelect-select": {
    "label + &": {},

    ".MuiInputBase-root.MuiInput-root": {
      marginTop: hasLabel ? pxToRem(26) : 0,
      padding: `${pxToRem(10)} ${pxToRem(12)} !important`,
      borderRadius: pxToRem(8),
      border: `1px solid ${theme.palette.stroke.strokeDefault}`,
      ":before": {
        display: "none",
      },
      ":after": {
        display: "none",
      },
      input: {
        padding: 0,
        marginRight: pxToRem(50),
      },
    },

    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    backgroundColor: `${theme.palette.background.bgPrimary}`,

    "& input": {
      padding: 0,
    },
    "&.Mui-error": {
      borderColor: `${theme.palette.text.textNegative} !important`,
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.background.bgTertiary,
      borderColor: theme.palette.background.bgTertiary,
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
      "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
      "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    },
    "&:focus-within": {
      borderColor: theme.palette.stroke.strokeBrand,
    },
    ":before": {
      display: "none",
    },
    ":after": {
      display: "none",
    },
    "& .MuiSelect-select": {
      background: "transparent !important",
      paddingTop: 0,
      paddingBottom: 0,
      padding: `${pxToRem(10)} ${pxToRem(12)}`,
      lineHeight: theme.typography.lineHeight.md,
      fontWeight: theme.typography.fw_regular_400,
    },
    svg: {
      path: {
        fill: theme.palette.icon.icDefault,
      },
      // marginRight: pxToRem(12),
    },
    li: {
      padding: pxToRem(16),
    },
  },
}));
